import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { IconButton, Typography } from '@material-ui/core'
import IconBack from '@material-ui/icons/ArrowBack'
import { fetchSiteForm, siteChange, clearSiteForm } from 'reducers/site/reducer'
import SiteForm from 'components/site/SiteForm'
import withPromise from 'helpers/withPromise'
import messages from 'components/site/translate'
import Loader from 'components/Loading'

class SiteItem extends Component {
  componentDidMount() {
    const { fetchSiteForm } = this.props

    fetchSiteForm({
      entityId: this.getEntityId(),
    })
  }

  componentWillUnmount() {
    const { clearSiteForm } = this.props

    clearSiteForm()
  }

  getEntityId() {
    const {
      match: {
        params: { id },
      },
    } = this.props

    return id !== 'create' ? id : false
  }

  onSubmit = values => {
    const {
      history: { goBack },
      siteChange,
    } = this.props

    return withPromise(siteChange, {
      entityId: this.getEntityId(),
      values,
    }).then(errors => (errors ? Promise.resolve(errors) : goBack()))
  }

  render() {
    const {
      isLoadForm,
      formData,
      history: { goBack },
    } = this.props

    if (isLoadForm) {
      return <Loader pastDelay />
    }

    return (
      <div className="container-fluid no-breadcrumb">
        <Typography variant="h5" className="headline">
          <IconButton size="medium" className="btn-back" onClick={goBack}>
            <IconBack fontSize="small" />
          </IconButton>
          <FormattedMessage {...messages.siteInfo} />
        </Typography>
        <SiteForm formData={formData.toJS()} onSubmit={this.onSubmit} />
      </div>
    )
  }
}

SiteItem.propTypes = {
  formData: PropTypes.object.isRequired,
  isLoadForm: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  fetchSiteForm: PropTypes.func,
  clearSiteForm: PropTypes.func,
  siteChange: PropTypes.func,
}

SiteItem.defaultProps = {
  fetchSiteForm: () => {},
  clearSiteForm: () => {},
  siteChange: () => {},
}

export default connect(
  state => ({
    isLoadForm: state.getIn(['site', 'isLoadForm']),
    formData: state.getIn(['site', 'formData']),
  }),
  {
    fetchSiteForm,
    clearSiteForm,
    siteChange,
  },
)(SiteItem)
